export default "__VITE_ASSET__Dvm_Du1W__"